import React from 'react';
import { motion } from 'framer-motion';
export function ModulesGrid() {
  const tomos = [{
    id: 1,
    lightColor: 'bg-[#0a1f15]/50',
    borderColor: 'border-[#1a3d2c]/50',
    textColor: 'text-slate-300',
    emoji: '📘',
    title: 'Planificación Docente Anual',
    subtitle: 'Todo lo que necesitás para organizar tu año desde el primer día',
    desc: 'Planificación anual completa, diseño curricular alineado a NAP y Ley 27.191, objetivos por trimestre, secuencias didácticas listas, cronograma anual, trimestral y mensual, instrumentos de seguimiento y modelos editables.',
    resuelve: 'El inicio del año suele ser caótico y sin estructura. Este tomo te da la planificación lista para presentar ante el directivo desde el día 1.',
    resultado: 'Tus alumnos reciben un año ordenado, con objetivos claros y contenidos alineados al diseño curricular jurisdiccional.',
    tags: ['PLANIFICACIÓN', 'NAP', 'SECUENCIAS', 'CRONOGRAMA', 'EDITABLE']
  }, {
    id: 2,
    lightColor: 'bg-[#0a1f15]/50',
    borderColor: 'border-[#1a3d2c]/50',
    textColor: 'text-slate-300',
    emoji: '📘',
    title: 'Energía Solar para el Aula',
    subtitle: 'El tomo que convierte la física solar en clases que tus alumnos entienden y recuerdan',
    desc: 'Radiación solar, paneles fotovoltaicos, sistemas on-grid y off-grid, aplicaciones educativas reales, laboratorios didácticos, actividades prácticas, casos reales argentinos (PUNA, NOA) y evaluación con clave.',
    resuelve: 'Explicar energía solar sin material adecuado genera clases abstractas. Este tomo trae los conceptos a la realidad argentina con casos concretos.',
    resultado: 'Tus alumnos comprenden cómo funciona un sistema solar real y pueden calcular generación básica con ejemplos de su propio contexto.',
    tags: ['SOLAR', 'PANELES', 'ON-GRID', 'OFF-GRID', 'ARGENTINA']
  }, {
    id: 3,
    lightColor: 'bg-[#0a1f15]/50',
    borderColor: 'border-[#1a3d2c]/50',
    textColor: 'text-slate-300',
    emoji: '📘',
    title: 'Energía Eólica y Otras Renovables',
    subtitle: 'El tomo que cubre todo el universo de las renovables con casos argentinos reales',
    desc: 'Energía eólica, aerogeneradores, casos argentinos del Atlas Eólico, biomasa, biogás, hidrógeno verde, geotermia, mareomotriz, trabajos prácticos completos y evaluación con clave.',
    resuelve: 'Los docentes no tienen material integrador sobre todas las renovables. Este tomo lo cubre todo con datos y casos de Argentina.',
    resultado: 'Tus alumnos conocen el sistema energético renovable completo con datos reales del SIGER, CAMMESA y el Atlas Eólico nacional.',
    tags: ['EÓLICA', 'BIOMASA', 'HIDRÓGENO', 'ATLAS EÓLICO', 'PATAGONIA']
  }, {
    id: 4,
    lightColor: 'bg-[#0a1f15]/50',
    borderColor: 'border-[#1a3d2c]/50',
    textColor: 'text-slate-300',
    emoji: '📘',
    title: 'Actividades y Trabajos Prácticos',
    subtitle: 'El tomo que transforma tu aula en un laboratorio activo de aprendizaje',
    desc: 'Actividades individuales y grupales, ABP (Aprendizaje Basado en Proyectos), resolución de problemas, construcción de maquetas, proyectos escolares, laboratorios simulados, debates, investigaciones guiadas e integradoras.',
    resuelve: 'Las clases expositivas sobre renovables aburren. Este tomo convierte cada clase en una experiencia participativa que genera compromiso real.',
    resultado: 'Tus alumnos participan activamente, desarrollan pensamiento crítico y conectan los contenidos con problemas energéticos reales.',
    tags: ['ABP', 'MAQUETAS', 'LABORATORIO', 'PROYECTOS', 'PARTICIPATIVO']
  }, {
    id: 5,
    lightColor: 'bg-[#0a1f15]/50',
    borderColor: 'border-[#1a3d2c]/50',
    textColor: 'text-slate-300',
    emoji: '📘',
    title: 'Evaluaciones y Rúbricas',
    subtitle: 'El tomo que cierra el ciclo de enseñanza con evaluaciones que realmente miden lo que importa',
    desc: 'Diagnósticos, evaluaciones formativas y sumativas, rúbricas analíticas y globales, autoevaluación, coevaluación, banco de preguntas y planillas de calificación listas.',
    resuelve: 'Armar evaluaciones de energías renovables lleva horas. Este tomo te da el sistema completo con criterios claros y corrección incluida.',
    resultado: 'Tus alumnos son evaluados con criterios justos, claros y coherentes. Vos corregís en minutos con la clave incluida.',
    tags: ['RÚBRICAS', 'DIAGNÓSTICO', 'FORMATIVA', 'SUMATIVA', 'CLAVE']
  }, {
    id: 6,
    lightColor: 'bg-[#1a3d2c]/60',
    borderColor: 'border-[#2a5a40]/80',
    textColor: 'text-slate-200',
    emoji: '⭐',
    title: 'Proyectos y Feria de Ciencias',
    subtitle: 'El tomo que lleva a tus alumnos del aula a la feria provincial con proyectos reales',
    desc: 'Ferias tecnológicas y científicas, proyectos escolares y comunitarios, proyectos ambientales, maquetas solares y aerogeneradores caseros, pósters, presentaciones orales, defensa ante jurado y vínculos con la comunidad.',
    resuelve: 'Llevar alumnos a una feria de ciencias sin guía es caótico. Este tomo estructura todo el proceso desde la idea hasta la defensa ante el jurado.',
    resultado: 'Tus alumnos presentan proyectos de impacto real con materiales profesionales y vos llegás a la feria con todo organizado.',
    tags: ['FERIA', 'PROYECTOS', 'MAQUETAS', 'JURADO', 'COMUNIDAD'],
    badge: '⭐ EL MÁS POPULAR'
  }];
  const bonos = [{
    id: 1,
    title: '100 Actividades Listas para Imprimir',
    valor: '$18.000 ARS',
    desc: 'Crucigramas, sopas de letras, cuestionarios, verdadero/falso, relacionar conceptos y completar esquemas sobre energías renovables. Todo listo para fotocopiar y entregar en clase sin preparación adicional.'
  }, {
    id: 2,
    title: 'Banco de Evaluaciones Editables',
    valor: '$15.000 ARS',
    desc: 'Exámenes completos, recuperatorios, diagnósticos, opción múltiple, preguntas de desarrollo, bancos de cálculo y evaluaciones de proceso. Todo editable en Word para adaptarlo a tu cátedra.'
  }, {
    id: 3,
    title: 'Presentaciones para Clase',
    valor: '$12.000 ARS',
    desc: 'Guiones completos para PowerPoint, Canva o Genially con título de cada slide, texto exacto, notas del presentador, descripción visual, infografías y láminas educativas listas para proyectar.'
  }, {
    id: 4,
    title: 'Recursos para Ferias de Ciencias',
    valor: '$10.000 ARS',
    desc: '20 ideas de proyectos renovables, guías paso a paso, materiales para exposición, modelos de presentación, rúbricas de jurado, cronograma docente, fichas de seguimiento y recursos para ferias provinciales y nacionales.'
  }];
  return <section className="py-20 bg-[#0c241a]" data-id="element-158">
      <div className="container mx-auto px-4" data-id="element-159">
        <div className="text-center mb-16" data-id="element-160">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#06140d]/80 text-slate-200 border border-[#1a3d2c]/50 font-bold mb-6 text-[16px]" data-id="element-161">
            📗 LOS 6 TOMOS
          </div>
          <h2 className="md:text-5xl font-extrabold text-white mb-4 text-[24px]" data-id="element-162">
            Un tomo por cada dimensión de la enseñanza
          </h2>
          <p className="text-slate-300 font-medium text-[16px]" data-id="element-163">
            Todo el sistema didáctico resuelto para docentes de energías
            renovables.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-6xl mx-auto mb-20" data-id="element-164">
          {tomos.map((tomo, i) => <motion.div key={tomo.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="rounded-2xl border border-[#1a3d2c] bg-[#06140d]/80 overflow-hidden shadow-lg hover:shadow-xl hover:border-slate-400/30 transition-all flex flex-col h-full relative" data-id="element-165">
              {tomo.badge && <div className="absolute top-0 right-0 bg-slate-200 text-slate-950 font-bold text-xs px-3 py-1 rounded-bl-lg z-10" data-id="element-166">
                  {tomo.badge}
                </div>}
              <div className={`${tomo.lightColor} p-4 border-b ${tomo.borderColor} flex items-center gap-3`} data-id="element-167">
                <div className="text-3xl" data-id="element-168">{tomo.emoji}</div>
                <div data-id="element-169">
                  <p className={`text-xs font-bold uppercase tracking-wider ${tomo.textColor}`} data-id="element-170">
                    Tomo {tomo.id}
                  </p>
                  <h3 className="font-bold text-white text-lg leading-tight" data-id="element-171">
                    {tomo.title}
                  </h3>
                </div>
              </div>
              <div className="p-6 flex-grow flex flex-col" data-id="element-172">
                <p className="font-semibold text-slate-300 mb-3 pb-3 border-b border-[#1a3d2c]" data-id="element-173">
                  {tomo.subtitle}
                </p>
                <p className="text-slate-300 text-sm leading-relaxed mb-4" data-id="element-174">
                  {tomo.desc}
                </p>
                <div className="bg-[#0c241a]/50 p-3 rounded-lg mb-4 border border-[#1a3d2c]/50" data-id="element-175">
                  <p className="text-xs text-slate-400 mb-1" data-id="element-176">
                    <strong data-id="element-177">¿Qué resuelve en el aula?</strong>
                  </p>
                  <p className="text-sm text-slate-300" data-id="element-178">{tomo.resuelve}</p>
                </div>
                <div className="bg-emerald-900/20 p-3 rounded-lg mb-4 border border-emerald-800/30" data-id="element-179">
                  <p className="text-xs text-emerald-300 mb-1" data-id="element-180">
                    <strong data-id="element-181">Resultado:</strong>
                  </p>
                  <p className="text-sm text-slate-200" data-id="element-182">{tomo.resultado}</p>
                </div>
                <div className="mt-auto flex flex-wrap gap-1.5" data-id="element-183">
                  {tomo.tags.map((tag, j) => <span key={j} className="text-[10px] font-bold uppercase tracking-wider bg-[#1a3d2c] text-slate-300 px-2 py-1 rounded" data-id="element-184">
                      {tag}
                    </span>)}
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center mb-12 border-t border-[#1a3d2c] pt-16" data-id="element-185">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#06140d]/80 text-slate-200 border border-slate-400/30 font-bold mb-6 text-[16px]" data-id="element-186">
            🎁 LOS 4 BONOS ESTRATÉGICOS
          </div>
          <h2 className="md:text-4xl font-extrabold text-white mb-4 text-[22px]" data-id="element-187">
            Siempre incluidos
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto mb-12" data-id="element-188">
          {bonos.map((bono, i) => <motion.div key={bono.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="rounded-2xl border border-[#1a3d2c] bg-[#06140d]/80 p-6 flex flex-col h-full relative overflow-hidden" data-id="element-189">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-slate-400 to-slate-200" data-id="element-190"></div>
              <h4 className="font-bold text-slate-300 mb-2 mt-2" data-id="element-191">
                BONO 0{bono.id}
              </h4>
              <h3 className="font-bold text-white text-lg mb-3" data-id="element-192">
                {bono.title}
              </h3>
              <p className="text-xs font-bold text-slate-400 mb-4 pb-3 border-b border-[#1a3d2c]" data-id="element-193">
                Valor real: <span className="line-through" data-id="element-194">{bono.valor}</span> →{' '}
                <span className="text-slate-200" data-id="element-195">GRATIS</span>
              </p>
              <p className="text-slate-300 text-sm leading-relaxed flex-grow" data-id="element-196">
                {bono.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-gradient-to-br from-[#0c241a] to-[#1a3d2c] rounded-2xl p-6 md:p-8 border border-slate-400/30 text-center shadow-2xl" data-id="element-197">
          <p className="text-slate-300 font-medium mb-2" data-id="element-198">
            Valor total de los 4 bonos: $55.000 ARS
          </p>
          <p className="text-2xl md:text-3xl font-black text-white mb-2" data-id="element-199">
            Tu precio hoy: <span className="text-slate-200" data-id="element-200">🎁 GRATIS</span> con
            tu Megapack
          </p>
        </motion.div>
      </div>
    </section>;
}